import React from "react";
import { Globe2 } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useT();
  const tf = t.footer;
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-slate-950 text-white border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-lg bg-[#005BEA] flex items-center justify-center">
              <Globe2 className="w-5 h-5 text-white" strokeWidth={2.4} />
            </div>
            <div className="leading-none">
              <div className="font-display font-bold tracking-tight text-[17px]">
                klairys
              </div>
              <div className="text-[10px] tracking-[0.18em] uppercase font-medium mt-0.5 text-white/60">
                .fr
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-md">
            {tf.description}
          </p>
        </div>

        <FooterCol
          title={tf.colCompany}
          links={[
            { label: tf.links.about, href: "#about" },
            { label: tf.links.services, href: "#services" },
            { label: tf.links.process, href: "#process" },
            { label: tf.links.careers, href: "#" },
          ]}
        />
        <FooterCol
          title={tf.colResources}
          links={[
            { label: tf.links.testimonials, href: "#testimonials" },
            { label: tf.links.partners, href: "#partners" },
            { label: tf.links.blog, href: "#" },
            { label: tf.links.faq, href: "#" },
          ]}
        />
        <FooterCol
          title={tf.colContact}
          links={[
            { label: tf.links.linkedin, href: "#" },
            { label: tf.links.quoteCta, href: "#contact" },
          ]}
        />
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/45">
          <p>© {year} klairys.fr — {tf.rights}</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white/80">{tf.legal}</a>
            <a href="#" className="hover:text-white/80">{tf.privacy}</a>
            <a href="#" className="hover:text-white/80">{tf.tos}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <div className="text-[10px] tracking-[0.22em] uppercase font-bold text-white/50 mb-4">
        {title}
      </div>
      <ul className="space-y-2.5">
        {links.map((l, i) => (
          <li key={i}>
            <a
              href={l.href}
              className="text-sm text-white/75 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
